import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  LinearProgress,
  Typography,
} from "@mui/material";

import { Grade, GRADES, SetSnackType, SettingsGrades } from "../../utils";
import { Dispatch, SetStateAction } from "react";

export const Settings = (props: {
  disconnect: () => void;
  openSettings: boolean;
  role: string;
  rowsLoading: boolean;
  setOpenSettings: Dispatch<SetStateAction<boolean>>;
  setSnack: SetSnackType;
  settingsGrades: SettingsGrades;
  updateGrade: (grade: Grade, checked: boolean) => Promise<void>;
}) => {
  return (
    <Dialog open={props.openSettings}>
      <DialogTitle>Settings</DialogTitle>
      <DialogContent>
        <DialogContentText>Admins have access to adjust some of these settings.</DialogContentText>
        <Box>
          <Typography variant="body1">Grades:</Typography>
          {props.rowsLoading ? <LinearProgress /> : <Box sx={{ minHeight: "4px" }}></Box>}
          <FormGroup sx={{ ml: 2 }}>
            {GRADES.map(g => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.settingsGrades[g as keyof SettingsGrades]}
                    onChange={(ev, checked) => props.updateGrade(g, checked)}
                    size="small"
                  />
                }
                disabled={props.role !== "SUPER-ADMIN"}
                key={g}
                label={g}
              />
            ))}
          </FormGroup>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.setOpenSettings(false)} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
